module.exports = __webpack_public_path__ + "img/软件产品证书-远程人工喊话系统V1.0.792751ee.jpg";